import { LinearProgress, Stack } from "@mui/material";
import { isEmpty, take } from "lodash";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../auth/AuthContext";
import Actions from "../../components/actions/Actions";
import AddFab from "../../components/actions/AddFab";
import InfiniteScroll from "../../components/infiniteScroll/InfiniteScroll";
import { useLimit } from "../../misc/useLimit";
import { useOpenInNewTab } from "../../misc/useOpenInNewTab";
import { useAdminFiltersValue } from "../useAdminFilters";
import ProviderCard from "./ProviderCard";
import { useProviders } from "./useProviders";

const ProvidersList = () => {
  const navigate = useNavigate();
  const { openChildInNewTab } = useOpenInNewTab();
  const { limit, loadMore } = useLimit();
  const { providers, isLoading } = useProviders();
  const { query } = useAdminFiltersValue("providers");
  const { context } = useAuthContext();
  const readOnly = context?.role === "AGENT" && !context?.customPrivileges.canEditProvidersProductsAndDictionaries;

  const filteredProviders = providers.filter((p) => isEmpty(query) || p.name.toLowerCase().includes(query));

  return (
    <Stack
      sx={{
        height: "100%",
      }}
    >
      {isLoading && <LinearProgress />}
      <InfiniteScroll
        dataLength={limit < filteredProviders.length ? limit : filteredProviders.length}
        hasMore={limit < filteredProviders.length}
        fetchData={loadMore}
      >
        {take(filteredProviders, limit).map((p) => (
          <ProviderCard
            key={p.id}
            value={{ ...p, contacts: p.contacts ?? [] }}
            onClick={() => navigate(p.id)}
            onContextMenu={() => openChildInNewTab(p.id)}
          />
        ))}
      </InfiniteScroll>
      <Actions>{!readOnly && <AddFab label="dodaj dostawcę" onClick={() => navigate("new")} />}</Actions>
    </Stack>
  );
};

export default ProvidersList;
